import { render } from "./PopUpEditKey.vue?vue&type=template&id=2b416d72"
import script from "./PopUpEditKey.vue?vue&type=script&lang=js"
export * from "./PopUpEditKey.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__